<mat-card [class]="cardConfig.cardClass">
  <mat-card-content>
    <div class="card-header">
      <h2 [class]="cardConfig.titleClass">{{ cardConfig.title }}</h2>
      <div class="card-header-actions">
        <ng-content select="[cardHeaderActions]"></ng-content>
      </div>
    </div>
    <p *ngIf="cardConfig.showSubtitle"
       class="subtitle"
       [class]="cardConfig.subtitleClass">
      {{ cardConfig.subtitle }}
    </p>
    <ng-content></ng-content>
  </mat-card-content>
</mat-card>
